import React from 'react'
import { ReactComponent as TextIcon } from '../../../../common/icons/text_circle_icon.svg'
import { ReactComponent as ImageIcon } from '../../../../common/icons/picture_circle_icon.svg'
import { ReactComponent as QuizIcon } from '../../../../common/icons/quiz_circle_icon.svg'
import { ReactComponent as VideoLibraryIcon } from '../../../../common/icons/video_circle_icon.svg'
import { ReactComponent as BrowserIcon } from '../../../../common/icons/browser_icon.svg'

export const ModuleType = {
  TEXT: 'TEXT',
  TEXT_IMAGE: 'TEXT_IMAGE',
  VIDEO: 'VIDEO',
  QUIZ: 'QUIZ',
  HTML: 'HTML'
}

export const moduleTypes = [
  {
    id: ModuleType.TEXT,
    title: 'Text',
    description: 'Present key information with a title and supporting text.',
    icon: <TextIcon />,
    comingSoon: false
  },
  {
    id: ModuleType.TEXT_IMAGE,
    title: 'Image + Text',
    description: 'Combine visuals with text for better understanding.',
    icon: <ImageIcon />,
    comingSoon: false
  },
  {
    id: ModuleType.QUIZ,
    title: 'Quiz',
    description: 'Test knowledge with single or multiple-choice questions.',
    icon: <QuizIcon />,
    comingSoon: false
  },
  {
    id: ModuleType.VIDEO,
    title: 'Video',
    description: 'Embed a video to engage users and enhance learning',
    icon: <VideoLibraryIcon />,
    comingSoon: false
  },
  {
    id: ModuleType.HTML,
    title: 'HTML',
    description: 'Create custom content with HTML for advanced layouts.',
    icon: <BrowserIcon />,
    comingSoon: false
  }
]
